import { useState } from "react";
import { showToast } from "../../utils/toastUtils";

interface UseRefundProps {
  onRefund: () => Promise<void>;
  close?: () => void;
}

const useRefund = ({ onRefund }: UseRefundProps) => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  const handleRefund = async () => {
    try {
      setIsProcessing(true);
      await onRefund();
      close?.();
      showToast("Invoice refunded successfully!", "success");
    } catch (error: any) {
      showToast(error.message || "An error occurred while processing the refund.", "error");
    } finally {
      setIsProcessing(false);
    }
  };

  return { isProcessing, handleRefund };
};

export default useRefund;
